import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Bind from 'lodash-decorators/bind';
import PrimaryButtonComponent from 'common/components/PrimaryButtonComponent/PrimaryButtonComponent';

import styles from './Modal.module.scss';

const modalRoot = document.getElementById('modal-root');

export default class Modal extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    onClose: PropTypes.func.isRequired
  };

  @Bind()
  onClose() {
    this.props.onClose();
  }

  render() {
    return !this.props.isOpen
      ? null
      : ReactDOM.createPortal(
          <div className={styles.Overlay}>
            <div className={styles.Modal}>
              <span className={styles.Close} onClick={this.onClose}>
                &times;
              </span>
              <div className={styles.Content}>
                <div
                  dangerouslySetInnerHTML={{
                    __html: this.props.children
                  }}
                />
                <div className={styles.ButtonWrapper}>
                  <PrimaryButtonComponent
                    className={styles.PrimaryButton}
                    text={'DALEJ'}
                    onClick={this.onClose}
                  />
                </div>
              </div>

              {/* <div className={styles.Content}>{this.props.children}</div> */}
            </div>
          </div>,
          modalRoot
        );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/Modal/Modal.js